import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Building2, Calendar, Mail, TrendingUp } from "lucide-react";

const StatCard = ({ label, value, icon: Icon, tint }) => (
  <div className="border border-[hsl(165_37%_17%/0.1)] rounded-md p-6 bg-white" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, "-")}`}>
    <div className="flex items-center justify-between mb-3">
      <p className="text-xs uppercase tracking-widest text-[hsl(100_3%_30%)]">{label}</p>
      <Icon className="h-4 w-4" style={{ color: tint }} />
    </div>
    <p className="font-serif-display text-3xl">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return <div className="text-[hsl(100_3%_30%)]">Loading…</div>;

  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Properties" value={stats.total_properties} icon={Building2} tint="hsl(10 51% 55%)" />
        <StatCard label="Bookings" value={stats.total_bookings} icon={Calendar} tint="hsl(165 37% 17%)" />
        <StatCard label="Revenue" value={`₹${stats.total_revenue.toLocaleString("en-IN")}`} icon={TrendingUp} tint="hsl(10 51% 55%)" />
        <StatCard label="New inquiries" value={stats.new_inquiries} icon={Mail} tint="hsl(165 37% 17%)" />
      </div>

      <div className="border border-[hsl(165_37%_17%/0.1)] rounded-md p-6 bg-white">
        <h3 className="font-serif-display text-xl mb-3">Quick actions</h3>
        <ul className="text-sm space-y-2 list-disc pl-5 text-[hsl(100_3%_30%)]">
          <li>Add or edit properties from the <strong>Properties</strong> tab.</li>
          <li>Confirm or cancel guest bookings under <strong>Bookings</strong>.</li>
          <li>Reply to concierge messages in <strong>Inquiries</strong>.</li>
        </ul>
      </div>
    </div>
  );
}
